import Vue from 'vue'
import VueRouter from 'vue-router'

/** Site */
import Home from '../views/Home.vue'
import PageNotFound from '../views/PageNotFound.vue'

/** Admin */
import Admin from '../views/admin/Admin.vue'
import Login from '../views/Login.vue'

//Course
import CourseList from '../views/admin/courses/CourseList.vue'
import CourseEdit from '../views/admin/courses/CourseEdit.vue'
import CourseRegister from '../views/admin/courses/CourseRegister.vue'

//Teaching
import TeachingList from '../views/admin/teachings/TeachingList.vue'
import TeachingEdit from '../views/admin/teachings/TeachingEdit.vue'
import TeachingRegister from '../views/admin/teachings/TeachingRegister.vue'

//Documents
import DocumentList from '../views/admin/teachings/documents/DocumentList.vue'
import DocumentRegister from '../views/admin/teachings/documents/DocumentRegister.vue'
import DocumentEdit from '../views/admin/teachings/documents/DocumentEdit.vue'

//Polo
import PoloList from '../views/admin/polos/PoloList.vue'
import PoloEdit from '../views/admin/polos/PoloEdit.vue'
import PoloRegister from '../views/admin/polos/PoloRegister.vue'

//Discipline
import DisciplineList from '../views/admin/disciplines/DisciplineList.vue'
import DisciplineEdit from '../views/admin/disciplines/DisciplineEdit.vue'
import DisciplineRegister from '../views/admin/disciplines/DisciplineRegister.vue'

//Stage
import StageList from '../views/admin/stages/StageList.vue'
import StageEdit from '../views/admin/stages/StageEdit.vue'
import StageRegister from '../views/admin/stages/StageRegister.vue'

//Student
import StudentList from '../views/admin/students/StudentList.vue'
import StudentEdit from '../views/admin/students/StudentEdit.vue'
import StudentRegister from '../views/admin/students/StudentRegister.vue'

//Team
import TeamList from '../views/admin/teams/TeamList.vue'
import TeamEdit from '../views/admin/teams/TeamEdit.vue'
import TeamRegister from '../views/admin/teams/TeamRegister.vue'
import TeamStudents from '../views/admin/teams/TeamStudents.vue'
import NotesRegister from '../views/admin/teams/students/NotesRegister.vue'

//User
import UserList from '../views/admin/users/UserList.vue'
import UserEdit from '../views/admin/users/UserEdit.vue'
import UserRegister from '../views/admin/users/UserRegister.vue'

//Candidate
import CandidateList from '../views/admin/candidates/CandidateList.vue'
import CandidateEdit from '../views/admin/candidates/CandidateEdit.vue'
import CandidateRegister from '../views/admin/candidates/CandidateRegister.vue'

//Grid
import GridList from '../views/admin/grids/GridList.vue'
import GridEdit from '../views/admin/grids/GridEdit.vue'
import GridRegister from '../views/admin/grids/GridRegister.vue'
import GridTemplateRegister from '../views/admin/grids/GridTemplateRegister.vue'

//Reports
import GeneralReportOfStudents from '../views/admin/reports/GeneralReportOfStudents.vue'
import DiarioDeClasse from '../views/admin/reports/DiarioDeClasse.vue'
import AlunosPorTurma from '../views/admin/reports/AlunosPorTurma.vue'
import AlunosDadosPorTurma from '../views/admin/reports/AlunosDadosPorTurma.vue'
import ReportFinancialByTeam from '../views/admin/reports/ReportFinancialByTeam.vue'
import CertificateOfCompletion from '../views/admin/reports/CertificateOfCompletion.vue'
import RegistrationStatement from '../views/admin/reports/RegistrationStatement.vue'
import StudentReportCard from '../views/admin/reports/StudentReportCard.vue'
import TransferReport from '../views/admin/reports/TransferReport.vue'
import AnnualPerformanceReport from '../views/admin/reports/AnnualPerformanceReport.vue'
import DefaultersReport from '../views/admin/reports/DefaultersReport.vue'
import Contract from '../views/admin/reports/Contract.vue'
import ReportFinancialWithFilter from '../views/admin/reports/ReportFinancialWithFilter.vue'
import BooksReport from '../views/admin/reports/BooksReport.vue'
import EnrolledStudentsReport from '../views/admin/reports/EnrolledStudentsReport.vue'
import StudentsWithDocumentsReport from '../views/admin/reports/StudentsWithDocumentsReport.vue'
import WeeklyFlowsReport from '../views/admin/reports/WeeklyFlowsReport.vue'
import ShipmentTrackingReport from '../views/admin/reports/ShipmentTrackingReport.vue'

//History
import HistoryRegister from '../views/admin/historys/HistoryRegister.vue'
//Certificate
import CertificateRegister from '../views/admin/certificates/CertificateRegister.vue'

//Dashboard
import Dashboard from '@/views/admin/Dashboard.vue'

// TaskTypes
import TaskTypeList from '@/views/admin/task-types/TaskTypeList.vue'
import TaskTypeRegister from '@/views/admin/task-types/TaskTypeRegister.vue'
import TaskTypeEdit from '@/views/admin/task-types/TaskTypeEdit.vue'

// Tasks
import TaskList from '@/views/admin/tasks/TaskList.vue'
import TaskRegister from '@/views/admin/tasks/TaskRegister.vue'
import TaskEdit from '@/views/admin/tasks/TaskEdit.vue'

// Weekly Flows
import WeeklyFlowList from '@/views/admin/weekly-flows/WeeklyFlowList.vue'
import WeeklyFlowShow from '@/views/admin/weekly-flows/WeeklyFlowShow.vue'

// Branches (Filiais Autorizadas)
import BranchList from '@/views/admin/branches/BranchList.vue'
import BranchForm from '@/views/admin/branches/BranchForm.vue'

// Document Templates
import DocumentTemplateList from '@/views/admin/document-templates/DocumentTemplateList.vue'
import DocumentTemplateForm from '@/views/admin/document-templates/DocumentTemplateForm.vue'

// Partner tokens (123Zap)
import PartnerTokenList from '@/views/admin/partners/PartnerTokenList.vue'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err
    })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err
    })
}

const routes = [
    {
        path: "*",
        component: PageNotFound
    },
    //Site
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/login',
        name: "login",
        component: Login,
    },
    {
        path: '/admin',
        component: Admin,
        meta: {
            login: true
        },
        children: [
            {
                path: 'dashboard',
                name: "dashboard",
                component: Dashboard,
            },
            {
                path: 'login',
                name: "login",
                component: Login,
            },
            {
                path: "cursos",
                name: "courses",
                component: CourseList,
            },
            {
                path: "cursos/registrar",
                name: "course-register",
                component: CourseRegister,
            },
            {
                path: "cursos/:id/editar",
                name: "course-edit",
                component: CourseEdit,
                props: true,
            },
            {
                path: "ensinos",
                name: "teachings",
                component: TeachingList,
            },
            {
                path: "ensinos/documentos",
                name: "documents",
                component: DocumentList
            },
            {
                path: "ensinos/:id/editar",
                name: "teaching-edit",
                component: TeachingEdit,
                props: true,
            },
            {
                path: "ensinos/registrar",
                name: "teaching-register",
                component: TeachingRegister,
            },
            // DOCUMENTOS
            {
                path: "ensinos/documentos/registrar",
                name: "document-register",
                component: DocumentRegister
            },
            {
                path: "ensinos/documentos/:id/editar",
                name: "document-edit",
                component: DocumentEdit,
                props: true,
            },
            // FIM
            {
                path: "polos",
                name: "polos",
                component: PoloList
            },
            {
                path: "polos/:id/editar",
                name: "polo-edit",
                component: PoloEdit,
                props: true,
            },
            {
                path: "polos/registrar",
                name: "polo-register",
                component: PoloRegister,
            },
            //Etapas
            {
                path: "etapas",
                name: "stages",
                component: StageList
            },
            {
                path: "etapas/:id/editar",
                name: "stage-edit",
                component: StageEdit,
                props: true,
            },
            {
                path: "etapas/registrar",
                name: "stage-register",
                component: StageRegister,
            },
            //Disciplines
            {
                path: "disciplinas",
                name: "disciplines",
                component: DisciplineList
            },
            {
                path: "disciplinas/:id/editar",
                name: "discipline-edit",
                component: DisciplineEdit,
                props: true,
            },
            {
                path: "disciplinas/registrar",
                name: "discipline-register",
                component: DisciplineRegister,
            },
            //Students
            {
                path: "alunos",
                name: "students",
                component: StudentList
            },
            {
                path: "alunos/:id/editar",
                name: "student-edit",
                component: StudentEdit,
                props: true,
            },
            {
                path: "alunos/registrar",
                name: "student-register",
                component: StudentRegister,
            },
            //Teams
            {
                path: "turmas",
                name: "teams",
                component: TeamList
            },
            {
                path: "turmas/:id/editar",
                name: "team-edit",
                component: TeamEdit,
                props: true,
            },
            {
                path: "turmas/:id/disciplinas",
                name: "team-disciplines",
                component: TeamStudents,
                props: true,
                children: [
                    {
                        path: ':discipline/alunos',
                        name: "disciplines-students",
                        component: NotesRegister,
                        props: true,
                    }
                ]
            },     
            {
                path: "turmas/registrar",
                name: "team-register",
                component: TeamRegister,
            },
            //Users
            {
                path: "usuarios",
                name: "users",
                component: UserList
            },
            {
                path: "usuarios/:id/editar",
                name: "user-edit",
                component: UserEdit,
                props: true,
            },
            {
                path: "usuarios/registrar",
                name: "user-register",
                component: UserRegister,
            },
            {
                path: "candidatos",
                name: "candidates",
                component: CandidateList,
            },
            {
                path: "candidatos/:id/editar",
                name: "candidate-edit",
                component: CandidateEdit,
                props: true,
            },
            {
                path: "candidatos/registrar",
                name: "candidate-register",
                component: CandidateRegister,
            },
            //Grids
            {
                path: "grades",
                name: "grids",
                component: GridList
            },
            {
                path: "grades/:id/editar",
                name: "grid-edit",
                component: GridEdit,
                props: true,
            },
            {
                path: "grades/registrar",
                name: "grid-register",
                component: GridRegister,
            },
            {
                path: "grades/registrar-template",
                name: "grid-template-register",
                component: GridTemplateRegister,
            },
            //Historys
            {
                path: "historico/:student/registrar",
                name: "history-register",
                component: HistoryRegister,
                props: true,
            },
            //Certificates
            {
                path: "certificado/:student/registrar",
                name: "certificate-register",
                component: CertificateRegister,
                props: true,
            },
            //Reports
            {
                path: "reports/general-report-of-students",
                name: "general-report-of-students",
                component: GeneralReportOfStudents,
            },
            {
                path: "reports/diario-de-classe",
                name: "diario-de-classe",
                component: DiarioDeClasse,
            },
            {
                path: "reports/alunos-por-turma",
                name: "alunos-por-turma",
                component: AlunosPorTurma,
            },
            {
                path: "reports/alunos-dados-completos-por-turma",
                name: "alunos-dados-completo-por-turma",
                component: AlunosDadosPorTurma,
            },
            {
                path: "reports/relatorio-financeiro-por-turma",
                name: "relatorio-financeiro-por-turma",
                component: ReportFinancialByTeam,
            },
            {
                path: "reports/atestado-de-conclusao-de-curso",
                name: "atestado-de-conclusao-de-curso",
                component: CertificateOfCompletion,
            },  
            {
                path: "reports/declaracao-de-matricula",
                name: "declaracao-de-matricula",
                component: RegistrationStatement,
            }, 
            {
                path: "reports/boletim-do-aluno",
                name: "boletim-do-aluno",
                component: StudentReportCard,
            },   
            {
                path: "reports/relatorio-de-repasse",
                name: "relatorio-de-repasse",
                component: TransferReport,
            },     
            {
                path: "reports/relatorio-de-desempenho-anual",
                name: "relatorio-de-desempenho-anual",
                component: AnnualPerformanceReport,
            }, 
            {
                path: "reports/inadimplentes",
                name: "inadimplentes",
                component: DefaultersReport,
            }, 
            {
                path: "reports/gerar-contrato",
                name: "gerar-contrato",
                component: Contract,
            },   
            {
                path: "reports/relatorio-financeiro-com-filtro",
                name: "relatorio-financeiro-com-filtro",
                component: ReportFinancialWithFilter,
            },
            {
                path: "reports/relatorio-de-livros",
                name: "relatorio-de-livros",
                component: BooksReport,
            },
            {
                path: "reports/relatorio-alunos-com-documentos",
                name: "relatorio-alunos-com-documentos",
                component: StudentsWithDocumentsReport,
            },
            {
                path: "reports/relatorio-alunos-matriculados",
                name: "relatorio-alunos-matriculados",
                component: EnrolledStudentsReport,
            },
            {
                path: "reports/relatorio-agenda-semanal",
                name: "relatorio-agenda-semanal",
                component: WeeklyFlowsReport,
            },
            {
                path: "reports/acompanhamento-de-envio",
                name: "acompanhamento-de-envio",
                component: ShipmentTrackingReport,
            },
            // Task Types
            {
                path: "tipos-de-tarefa",
                name: "task-types",
                component: TaskTypeList,
            },
            {
                path: "tipos-de-tarefa/registrar",
                name: "task-type-register",
                component: TaskTypeRegister,
            },
            {
                path: "tipos-de-tarefa/:id/editar",
                name: "task-type-edit",
                component: TaskTypeEdit,
                props: true,
            },
            // Tasks
            {
                path: "tarefas",
                name: "tasks",
                component: TaskList,
            },
            {
                path: "tarefas/registrar",
                name: "task-register",
                component: TaskRegister,
            },
            {
                path: "tarefas/:id/editar",
                name: "task-edit",
                component: TaskEdit,
                props: true,
            },
            // Weekly Flows
            {
                path: "agenda-semanal",
                name: "weekly-flows",
                component: WeeklyFlowList,
            },
            {
                path: "agenda-semanal/:id",
                name: "weekly-flow-show",
                component: WeeklyFlowShow,
                props: true,
            },
            // Branches
            {
                path: "filiais",
                name: "branches",
                component: BranchList,
            },
            {
                path: "filiais/registrar",
                name: "branch-register",
                component: BranchForm,
            },
            {
                path: "filiais/:id/editar",
                name: "branch-edit",
                component: BranchForm,
                props: true,
            },
            // Document Templates
            {
                path: "modelos-de-documentos",
                name: "document-templates",
                component: DocumentTemplateList,
            },
            {
                path: "modelos-de-documentos/registrar",
                name: "document-template-register",
                component: DocumentTemplateForm,
            },
            {
                path: "modelos-de-documentos/:id/editar",
                name: "document-template-edit",
                component: DocumentTemplateForm,
                props: true,
            },
            {
                path: "partner-tokens",
                name: "partner-tokens",
                component: PartnerTokenList,
            },
        ]
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.login)) {
        if (!window.localStorage.token) {
            next("login");
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router